import LocaleDropdown from './LocaleDropdown';

export { type LocaleDropdownProps } from './LocaleDropdown';
export default LocaleDropdown;
